export default "__VITE_ASSET__XyTWZJwI__"